import React from 'react';
import { getTickDisplayStr } from '@jbrowse/core/util';
import { useTheme } from '@mui/material';
// locals
import { makeTicks } from '../util';
import SVGRegionSeparators from './SVGRegionSeparators';
function Ruler(_ref) {
  var start = _ref.start,
    end = _ref.end,
    bpPerPx = _ref.bpPerPx,
    _ref$reversed = _ref.reversed,
    reversed = _ref$reversed === void 0 ? false : _ref$reversed,
    _ref$major = _ref.major,
    major = _ref$major === void 0 ? true : _ref$major,
    _ref$minor = _ref.minor,
    minor = _ref$minor === void 0 ? true : _ref$minor,
    _ref$hideText = _ref.hideText,
    hideText = _ref$hideText === void 0 ? false : _ref$hideText;
  var ticks = makeTicks(start, end, bpPerPx, major, minor);
  var theme = useTheme();
  return React.createElement(React.Fragment, null, ticks.map(function (tick) {
    var x = (reversed ? end - tick.base : tick.base - start) / bpPerPx;
    return React.createElement("line", {
      key: tick.base,
      x1: x,
      x2: x,
      y1: 0,
      y2: tick.type === 'major' ? 6 : 4,
      strokeWidth: 1,
      stroke: theme.palette.text.secondary
    });
  }), !hideText ? ticks.filter(function (tick) {
    return tick.type === 'major';
  }).map(function (tick) {
    var x = (reversed ? end - tick.base : tick.base - start) / bpPerPx;
    return React.createElement("text", {
      x: x - 3,
      y: 7 + 11,
      key: "label-".concat(tick.base),
      fontSize: 11,
      fill: theme.palette.text.primary
    }, getTickDisplayStr(tick.base + 1, bpPerPx));
  }) : null);
}
export default function SVGRuler(_ref2) {
  var model = _ref2.model,
    fontSize = _ref2.fontSize;
  var contentBlocks = model.dynamicBlocks.contentBlocks,
    viewOffsetPx = model.offsetPx,
    bpPerPx = model.bpPerPx;
  var renderRuler = contentBlocks.length < 5;
  var theme = useTheme();
  return React.createElement(React.Fragment, null, React.createElement(SVGRegionSeparators, {
    model: model,
    height: 30
  }), contentBlocks.map(function (block) {
    var start = block.start,
      end = block.end,
      key = block.key,
      reversed = block.reversed,
      offsetPx = block.offsetPx,
      refName = block.refName,
      widthPx = block.widthPx;
    var offset = offsetPx - viewOffsetPx;
    var clipid = "clip-".concat(key);
    return React.createElement("g", {
      key: key
    }, React.createElement("defs", null, React.createElement("clipPath", {
      id: clipid
    }, React.createElement("rect", {
      x: 0,
      y: 0,
      width: widthPx,
      height: 100
    }))), React.createElement("g", {
      transform: "translate(".concat(offset, " 0)")
    }, React.createElement("g", {
      clipPath: "url(#".concat(clipid, ")")
    }, React.createElement("text", {
      x: 4,
      y: fontSize,
      fontSize: fontSize,
      fill: theme.palette.text.primary
    }, refName), React.createElement("g", {
      transform: "translate(0 20)"
    }, React.createElement(Ruler, {
      hideText: !renderRuler,
      start: start,
      end: end,
      bpPerPx: bpPerPx,
      reversed: reversed
    })))));
  }));
}